import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 202	循环
 */

export default class EventLoop extends EventBase {
  /**
   * 循环的构造函数
   */
  constructor() {
    super()
    this.Parameter = ['']
  }
  /**
   * 剧情ID
   */
  Code = EventID.Loop
  /**
   * 获取显示信息
   */
  /// <returns></returns>
}
